import {
  toURL
} from '@homeaway/search-url-parser';
import Cookies from 'js-cookie';

import {
  SEARCH_COOKIE
} from '../../config/constants';

// This method fixes a problem with toUrl + filters. We should be passing filter=[propertyTypeSerpFilter] to the toUrl method instead.
// We cannot update the url parser at the moment because we could put the react migration experiment on risk .
const getFilterTerm = (siteName, filterTerm) => {
  return siteName === 'vrbo' ?
    `&filter=${filterTerm}` :
    `/${filterTerm}`;
};

export const buildPropertyTypeSerpUrl = ({ siteName, destination, propertyTypeSerpFilter }) => {
  const cookie = Cookies.getJSON(SEARCH_COOKIE) || {
    arrival: '',
    departure: ''
  };

  const {
    arrival,
    departure
  } = cookie;


  const url = toURL({
    arrival,
    departure,
    q: destination
  }, {
    name: siteName
  });

  return `${url}${getFilterTerm(siteName, propertyTypeSerpFilter)}`;
};

export const getSubtitle = (subtitleTemplate, formattedCount, propertyTypePlural) =>
  subtitleTemplate
    .replace('{propertyCount}', formattedCount)
    .replace('{propertyTypePluralNoArticle}', propertyTypePlural);



// WEBPACK FOOTER //
// ./src/universal/components/PropertyTypes/utils.js